import React, { useState, useEffect } from 'react';
import UserIcon from 'assets/icon/UserIcon';
import CategoryIcon from 'assets/icon/CategoryIcon';
import SettingIcon from 'assets/icon/SettingIcon';
import NotepadIcon from 'assets/icon/NotepadIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import DoorOpenIcon from 'assets/icon/DoorOpenIcon';
import CreditCardIcon from 'assets/icon/CreditCardIcon';
import GroupIcon from 'assets/icon/GroupIcon';
import BankIcon from 'assets/icon/BankIcon';
import { MenuIncProjectId, MenuPaymentId, MenuPaymentSubConId, MenuProductionBankId, MenuProjectId, MenuSubConId } from 'utils/Constant';
import WalletIcon from 'assets/icon/WalletIcon';
import ProductionBank from 'pages/CompanyPages/ProductionBank/ProductionBank';

export default function Sidebar({ isOpen, onSidebarClick, menuAccess }) {
	const [isSidebarHome, setIsSidebarHome] = useState(true)
	const [isAdmin, setIsAdmin] = useState("0")

	const [showHome, setShowHome] = useState(false)
	const [showCompany, setShowCompany] = useState(false)
	const [showBank, setShowBank] = useState(false)
	const [showProject, setShowProject] = useState(false)
	const [showPayment, setShowPayment] = useState(false)
	const [showPaymentSubContractor, setShowPaymentSubContractor] = useState(false)
	const [showSubContractor, setShowSubContractor] = useState(false)
	const [showIncProject, setShowIncProject] = useState(false)
	const [showProductionBank, setShowProductionBank] = useState(false)

	let pathArray = window.location.pathname.split("/")
	
	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
		// setIsAdmin("1")
	}, [])

	useEffect(() => {
		if (pathArray[1] === "company"){
			setIsSidebarHome(false)

			let userAccess = JSON.parse(localStorage.getItem("UserAccessMenu"))
			
			for (let i=0; i < userAccess.length; i++){
				if(String(userAccess[i].menuId) === MenuProjectId){
					if(userAccess[i].access){
						setShowProject(true)
					}else{
						setShowProject(false)
					}
				}
				if(String(userAccess[i].menuId) === MenuPaymentId){
					if(userAccess[i].access){
						setShowPayment(true)
					}else{
						setShowPayment(false)
					}
				}
				if(String(userAccess[i].menuId) === MenuPaymentSubConId){
					if(userAccess[i].access){
						setShowPaymentSubContractor(true)
					}else{
						setShowPaymentSubContractor(false)
					}
				}
				if(String(userAccess[i].menuId) === MenuIncProjectId){
					if(userAccess[i].access){
						setShowIncProject(true)
					}else{
						setShowIncProject(false)
					}
				}
				if(String(userAccess[i].menuId) === MenuSubConId){
					if(userAccess[i].access){
						setShowSubContractor(true)
					}else{
						setShowSubContractor(false)
					}
				}
				if(String(userAccess[i].menuId) === MenuProductionBankId){
					if(userAccess[i].access){
						setShowProductionBank(true)
					}else{
						setShowProductionBank(false)
					}
				}
			}
		}else{
			setIsSidebarHome(true)
		}
	}, [pathArray])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 ${ isOpen ? 'w-72' : 'hidden sm:block sm:w-20' } `}>
			{ isSidebarHome ?
				// Home Sidebar
				<div className={`h-screen flex flex-col items-center gap-6 md:text-xs lg:text-base py-4 w-full`}>
					<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname === '/' ? 'bg-slate-300' : '' } 
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
							`}
							onClick={onSidebarClick}
							href="/"
						>
							<DashboardIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Home</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company-setting') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
								${ isAdmin === "1" ? 'block' : 'hidden' }
							`}
							onClick={onSidebarClick}
							href="/company-setting"
						>
							<CategoryIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Company</p>
						</a>
						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/contractor-setting') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
								${ isAdmin === "1" ? 'block' : 'hidden' }
							`}
							onClick={onSidebarClick}
							href="/contractor-setting"
						>
							<CategoryIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Contractor</p>
						</a>
						<a
							className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/user-setting') ? 'bg-slate-300' : '' } 
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
								${ isAdmin === "1" ? 'block' : 'hidden' }
							`}
							onClick={onSidebarClick}
							href="/user-setting"
						>
							<UserIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>User</p>
						</a>
						<a
							className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname === '/bank' ? 'bg-slate-300' : '' } 
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
								${ isAdmin === "1" ? 'block' : 'hidden' }
							`}
							onClick={onSidebarClick}
							href="/bank"
						>
							<BankIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Bank</p>
						</a>
					</div>
				</div>	
				:
				// Company Sidebar
				<div className={`h-screen flex flex-col items-center gap-6 text-base py-4 w-full`}>
					<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/project') ? 'bg-slate-300' : '' } 
								${ isOpen ? 'px-4' : 'justify-center px-2' } 
								${ showProject ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/project"
						>
							<NotepadIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Project</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/payment-client') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'px-2 justify-center' }
								${ showPayment ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/payment-client"
						>
							<CreditCardIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Payment Client</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/payment-subcontractor') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'px-2 justify-center' }
								${ showPaymentSubContractor ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/payment-subcontractor"
						>
							<CreditCardIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Payment SubCon</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/income') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'px-2 justify-center' }
								${ showIncProject ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/income"
						>
							<WalletIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Inc Project</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/subcon') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'px-2 justify-center' }
								${ showSubContractor ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/subcon"
						>
							<WalletIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Sub Contractor</p>
						</a>

						<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
								${ window.location.pathname.includes('/company/production-bank') ? 'bg-slate-300' : '' }
								${ isOpen ? 'px-4' : 'px-2 justify-center' }
								${ showProductionBank ? 'flex' : 'hidden' } 
							`}
							onClick={onSidebarClick}
							href="/company/production-bank"
						>
							<BankIcon className='fill-black w-6' />
							<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Production Bank</p>
						</a>
					</div>
				</div>
			}
		</div>
  	)
}
